import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class SliderMedias {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-medias__swiper', {
      modules: [Pagination],
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 24,
      grabCursor: true,
      preventInteractionOnTransition: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    });
  }
}

export const sliderMedias = new SliderMedias();
